import { IWorkgroupData } from '@/models';
import { IWorkgroupService } from './workgroup.types';
import { AxiosInstance } from 'axios';

export class WorkgroupService implements IWorkgroupService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/workgroups/';
  }

  fetchWorkgroups(): Promise<IWorkgroupData[]> {
    return this.axios
      .get<IWorkgroupData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchWorkgroup(id: number): Promise<IWorkgroupData> {
    return this.axios
      .get<IWorkgroupData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createWorkgroup(data: IWorkgroupData): Promise<IWorkgroupData> {
    return this.axios
      .post<IWorkgroupData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateWorkgroup(data: IWorkgroupData): Promise<IWorkgroupData> {
    return this.axios
      .patch<IWorkgroupData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteWorkgroup(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
